import { render } from "./BrandLogoBarnerFooter.vue?vue&type=template&id=38d628cb&scoped=true"
import script from "./BrandLogoBarnerFooter.vue?vue&type=script&lang=js"
export * from "./BrandLogoBarnerFooter.vue?vue&type=script&lang=js"

import "./BrandLogoBarnerFooter.vue?vue&type=style&index=0&id=38d628cb&scoped=true&lang=css"

import exportComponent from "/Users/kellyluo/Work/projects/icheer-web-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d628cb"]])

export default __exports__